"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagediyDeleteApi = pagediyDeleteApi;
exports.pagediyGetSetHome = pagediyGetSetHome;
exports.pagediyInfoApi = pagediyInfoApi;
exports.pagediyListApi = pagediyListApi;
exports.pagediySaveApi = pagediySaveApi;
exports.pagediySetdefaultApi = pagediySetdefaultApi;
exports.pagediyUpdateApi = pagediyUpdateApi;
exports.pagediyUpdatenameApi = pagediyUpdatenameApi;
exports.splashGetApi = splashGetApi;
exports.splashSaveApi = splashSaveApi;
exports.wechatQrcodeApi = wechatQrcodeApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * @description diy 新增
 */
function pagediySaveApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/pagediy/save',
    method: 'post',
    data: data
  });
}

/**
 * @description diy 列表
 */
function pagediyListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/pagediy/list',
    method: 'get',
    params: params
  });
}

/**
 * @description diy 详情
 */
function pagediyInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/pagediy/info/".concat(id),
    method: 'get'
  });
}

/**
 * @description diy 修改
 */
function pagediyUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pagediy/update",
    method: 'post',
    data: data
  });
}

/**
 * @description diy 设置商城首页
 */
function pagediySetdefaultApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/pagediy/setdefault/".concat(id),
    method: 'get'
  });
}

/**
 * @description diy 设置商城删除
 */
function pagediyDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/pagediy/delete",
    method: 'get',
    params: params
  });
}

/**
 * 查询已经设置的首页diy 模版id
 * @returns {*}
 */
function pagediyGetSetHome() {
  return (0, _request.default)({
    url: "/admin/platform/pagediy/getdefault",
    method: 'get'
  });
}

/**
 * 获取小程序二维码
 * @returns {*}
 */
function wechatQrcodeApi(data) {
  return (0, _request.default)({
    url: "/publicly/wechat/mini/get/qrcode",
    method: 'post',
    data: data
  });
}

/**
 * DIY 模版名称更新
 * @returns {*}
 */
function pagediyUpdatenameApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pagediy/updatename",
    method: 'post',
    data: data
  });
}

/**
 * 获取开屏广告配置
 * @returns {*}
 */
function splashGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/page/layout/splash/ad/get",
    method: 'get'
  });
}

/**
 * 编辑开屏广告配置
 * @returns {*}
 */
function splashSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/page/layout/splash/ad/save",
    method: 'post',
    data: data
  });
}